module.exports = __webpack_public_path__ + "img/Path 13 Copy@3x.6a0effbd.png";